import { doPost2, doGet2 } from './common'
const baseUrl = '/videoUpload'
/*
{
  "address1": "string",
  "address2": "string",
  "caption": "string",
  "city": "string",
  "email": "string",
  "firstName": "string",
  "id": 0,
  "lastName": "string",
  "state": "string",
  "title": "string",
  "uploadFile": "string",
  "zipCode": "string"
}
*/

export const getSubmissionStatus = async payload => {
  let resp = await doGet2(`${baseUrl}/status`, payload)
  let data = await resp.json()
  return data
}

//Request that the api send a reminder email to user later on.
export const requestEmailReminder = (
  breakId,
  stepId,
  receiptId,
  email,
  link,
  turnstileToken,
) => {
  try {
    const payload = {
      breakId: breakId,
      stepId: stepId,
      videoUploadId: receiptId,
      email: email,
      link: link,
      turnstileToken: turnstileToken,
    }

    return doPost2(`${baseUrl}/schedule`, payload)
  } catch (e) {
    console.log(`Error in requestEmailReminder: ${e}`)
    return
  }
}

const submit = payload => {
  try {
    return doPost2(`${baseUrl}/submit`, payload)
  } catch (e) {
    console.log(`Error in submit video upload: ${e}`)
    return
  }
}
export { submit }
